export default "__VITE_ASSET__Dik9d_EP__"